import { SanityPage } from '~/types';

export default function useJsonLdMeta(page: SanityPage | null) {
  const { t } = useI18n();
  if (!page) return;

  // If the page is the home page, isHome will be true. Otherwise, it will be false.
  const isHome = page?.isHome || false;

  // The pageUrl is the full path to the page, including the locale. If the page is the home page, pageUrl will be an empty string.
  const pageUrl = page.url ? page.url?.fullPath : '';

  // The page's locale. If the page is the home page, locale will be an empty string.
  const locale = page.__i18n_lang || '';

  // The page's title. If the page doesn't have a title, it will be the default website title.
  const name = page.seoMetadata?.title || t('seo.websiteTitle');

  // The page's description. If the page doesn't have a description, it will be the default description.
  const description = page.seoMetadata?.description || t('seo.description');

  // The page's full URL. If the page is the home page, url will be the base URL.
  const url = useGetPageBaseUrl(isHome, pageUrl, locale);

  // The base metadata for the page.
  const baseMeta = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url
  });

  // Add the base metadata to the document's head.
  useHead({
    script: {
      type: 'application/ld-json',
      children: baseMeta
    }
  });
}
